define(function(require) {
    const TokensTemplate = require('./Tokens.template.html');
    const NewTokenTemplate = require('./NewToken.template.html');

    const BaseView = require('app/Base.view');
    const TokenView = require('./Token.view');

    const TokenCollection = require('models/user/Tokens.collection');
    const ConfirmationModalView = require('app/modals/ConfirmationModal.view');
    const TokenModel = require('models/user/Tokens.model');
    const _ = require('underscore');
    const CC = require('CC');
    const DataGrid = require('components/DataGrid');
    const Clipboard = require('vendor/clipboard');

    require('backgridViewCell');

    const TokensView = BaseView.extend({
        template: _.template(TokensTemplate),

        defaults: function() {
            return {};
        },

        events: {
            'click .create-token': 'handleCreateClick'
        },

        initialize: function(options) {
            _.extend(this, this.defaults(), options);

            this.gridCollection = new TokenCollection();
            this.listenTo(CC.Events, 'token:delete', this.renderDeleteConfirmationModal);
            this.listenTo(this.gridCollection, 'sync', this.updateCreateButton);
        },

        render: function() {
            this.$el.html(this.template());
            this.renderGrid();
            return this;
        },

        renderGrid: function() {
            const columnBuilder = new DataGrid.ColumnBuilder()
                .text('token', 'Token', {
                    sortable: false,
                    onDisplay: (data, type, row, meta, translatedValue) => {
                        if (data === null) {
                            return '*******************************';
                        }
                        return `<code>${data}</code>`;
                    }
                })
                .text('accessKey', 'Access Key', {
                    sortable: false,
                    onDisplay: (data, type, row, meta, translatedValue) => {
                        return `<code>${data}</code>`;
                    }
                })
                .text('description', 'Description', {
                    sortable: false
                })
                .actionBuilder(
                    new DataGrid.ActionBuilder({ eventPrefix: 'token' }).delete({
                        title: 'Deactivate Token'
                    })
                );

            this.grid = this.renderSubView('#tokens_grid', DataGrid, {
                columns: columnBuilder.buildColumns(),
                collection: this.gridCollection,
                hasSearch: false,
                hasPaging: false,
                hasExport: false,
                emptyTableMessage: 'No API Tokens found',
                deferLoading: false
            });
        },

        handleCreateClick: function() {
            const token = new TokenModel();
            CC.Events.trigger(
                'Page:showModal',
                new ConfirmationModalView({
                    modalId: 'showcase-node-confirm',
                    saveText: 'Create',
                    modalTitle: 'Create New Token',
                    closeOnEnterKey: true,
                    contentView: new TokenView({
                        model: token
                    }),
                    confirmed: () => {
                        this.gridCollection.fetch();
                        const newTokenTemplate = _.template(NewTokenTemplate);
                        this.$('#new_token').html(
                            newTokenTemplate({
                                token: token.get('token'),
                                description: token.get('description'),
                                accessKey: token.get('accessKey')
                            })
                        );
                        this.clipboard = new Clipboard('.lotacon-clipboard');
                        this.clipboard.on('success', e => {
                            this.renderAlert({
                                alertType: 'success',
                                message: `${e.text} is now on your clipboard!`
                            });
                        });
                    }
                })
            );
        },

        renderDeleteConfirmationModal: function(token) {
            const escapedDescription = _.escape(token.get('description'));
            CC.Events.trigger(
                'Page:showModal',
                new ConfirmationModalView({
                    modalId: 'token-deactivate-confirm',
                    modalTitle: `Deactivate Token \`${escapedDescription}\``,
                    alertType: 'danger',
                    savingText: 'Deactivating...',
                    confirmMessage: `Are you sure you want to deactivate the token "${escapedDescription}"?`,
                    saveText: 'Deactivate',
                    save: () => {
                        return this.deactivateToken(token);
                    }
                })
            );
        },

        deactivateToken: function(token) {
            const t = token.destroy({
                wait: true
            });
            t.always(() => {
                this.renderAlert({
                    alertType: 'success',
                    message: `The token '${_.escape(token.get('description'))}' has been deactivated.`
                });

                this.gridCollection.fetch();
            });
            return true;
        },

        updateCreateButton: function() {
            if (this.gridCollection.length < 2) {
                this.$('#create_token')
                    .removeClass('disabled')
                    .removeAttr('disabled')
                    .removeAttr('title');
            } else {
                this.$('#create_token')
                    .addClass('disabled')
                    .attr({
                        disabled: 'disabled',
                        title: 'You may not create a token if you currently have more than one token active.'
                    });
            }
        }
    });

    return TokensView;
});
